<template>
  <div style="padding: 35px; padding-top: 15px">
    <transition name="tour-guide-fade">
      <div
        v-if="showTitles"
        class="mb-6 py-2 mt-7 px-3 rounded-lg gift-feature-card"
      >
        <div class="gift-content-wrapper">
          <div class="gift-icon-column">
            <div class="gift-icon-container">
              <v-icon
                color="white"
                size="15"
              >
                {{ icons.mdiGift }}
              </v-icon>
            </div>
          </div>
          <div class="gift-text-column">
            <div class="d-flex align-center">
              <span class="font-weight-medium text-body-2 primary--text">{{ $t('gift_tip_title') }}</span>
            </div>
            <div class="text-caption secondary--text my-1">
              {{ $t('gift_tip_statistics') }}
              <span class="money-icon">💰</span>
            </div>
            <a
              class="text-caption primary--text font-weight-medium d-inline-block gift-link"
              @click="navigateToGiftSettings"
            >
              {{ $t('gift_tip_register_recommendation') }}
            </a>
          </div>
        </div>
      </div>
    </transition>

    <transition name="tour-guide-fade">
      <div v-if="showTitles">
        <div class="text-2xl text-2xl font-weight-bold">
          <span>
            {{ $t('we_do_almost_all_job') }}
          </span>
          <span class="black--text">
            {{ $t('you_need_only_add_guests') }}
          </span>
        </div>
      </div>
    </transition>

    <div class="py-5 text-center mt-2">
      <!-- import guests from excel file -->
      <transition name="tour-guide-fade">
        <div v-if="showTitles">
          <ImportFromExcel
            :import-contacts-from-tour-guide="true"
            @moveToGuestList="moveToGuestList"
          ></ImportFromExcel>
        </div>
      </transition>

      <!-- import guests from google account -->
      <transition name="tour-guide-fade">
        <div v-if="showTitles">
          <GoogleContacts
            :import-contacts-from-tour-guide="true"
            @moveToGuestList="moveToGuestList"
          ></GoogleContacts>
        </div>
      </transition>

      <!-- add guests manually -->
      <transition name="tour-guide-fade">
        <v-btn
          v-if="showTitles"
          x-large
          block
          outlined
          elevation="8"
          class="justify-center align-center rounded-lg my-2"
          @click="moveToGuestList"
        >
          <v-icon
            color="teal"
            size="30"
            right
          >
            {{ icons.mdiGestureTap }}
          </v-icon>
          <span
            class="mx-2"
            style="margin: 13px !important;"
          >
            {{ $t('AddManually') }}
          </span>
        </v-btn>
      </transition>
      <div class="text-center pt-1">
        <!-- add guests later -->
        <transition name="tour-guide-fade">
          <a
            v-if="showTitles"
            style="color: #b9afc6; text-decoration: underline;"
            text
            @click="moveToGuestList"
          >
            {{ $t('add_guests_later') }}
          </a>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleContacts from '@/components/GuestManagement/ImportInvitees/GoogleContacts.vue'
import ImportFromExcel from '@/components/GuestManagement/ImportInvitees/ImportFromExcel.vue'
import router from '@/router'
import store from '@/store'
import { mdiChevronLeft, mdiGestureTap, mdiGift } from '@mdi/js'
import { watchEffect } from '@vue/composition-api'
import { useTourGuideTitleAnimation } from '../useTourGuideTitleAnimation'

export default {
  name: 'Guests',
  components: { GoogleContacts, ImportFromExcel },
  props: {
    currentStep: {
      required: true,
    },
    stepIndex: {
      required: true,
    },
  },
  setup(props) {
    const { showTitles } = useTourGuideTitleAnimation(props)

    const moveToGuestList = () => {
      store.commit('setTourGuide', { value: false, type: '' })
    }

    const navigateToGiftSettings = () => {
      store.commit('setTourGuide', { value: false, type: '' })

      router.push({ name: 'credit-gifts' })
    }

    watchEffect(() => {
      if (router.currentRoute.name === 'apps-user-list') return

      router.push({ name: 'apps-user-list' })
    })

    return {
      moveToGuestList,
      navigateToGiftSettings,
      showTitles,

      icons: {
        mdiGestureTap,
        mdiGift,
        mdiChevronLeft,
      },
    }
  },
}
</script>

<style scoped>
.gift-feature-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 8px rgba(145, 85, 253, 0.05);
  position: relative;
  border: 1px solid rgba(145, 85, 253, 0.08);
}

.gift-content-wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
}

.gift-icon-column {
  display: flex;
  align-items: center;
}

.gift-icon-container {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gift-text-column {
  display: flex;
  flex-direction: column;
}

.gift-link {
  text-decoration: none;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.gift-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.money-icon {
  font-size: 13px;
  line-height: 1;
}
</style>
